export default {
  title: {
    vi: 'Thông tin cá nhân',
    en: 'Profile'
  }
};
